"use client";
import { clickEvent, fbqEvent, gtmEvent } from "@/lib/atInternetTags";
import type { SearchDeparture, SearchTravel } from "front-search-schema/algolia";

export const requestProgrammeOnSuccessSearch = (travel: SearchTravel, departure: SearchDeparture) => {
  clickEvent({
    event: "click.download",
    goal_type: "program_request",
    click: travel.alias || "",
    click_chapter1: "infosup",
    product: travel.alias || "",
    product_id: travel.id.toString(),
    product_brand: travel.brandTitle || "",
    product_discount: departure.primoPrice !== null,
    product_variant: travel.travelTypeId,
    product_pricetaxincluded: departure.primoPrice
      ? (departure.defaultPrice || 0) - departure.primoPrice
      : departure.defaultPrice || 0,
    product_category1: travel.destinationAliases[0] || "",
    product_category2: travel.destinationAliases[1] || "",
    travel_duration: departure.days || 0,
    speaker_ids: departure.speakers.map(({ id }) => id.toString()),
    registration_status: departure.state.registrationStatus,
  });

  gtmEvent("programme");
  fbqEvent("trackCustom", "ProgramDownload", {
    content_ids: travel.id,
    value: departure.primoPrice ? (departure.defaultPrice || 0) - departure.primoPrice : departure.defaultPrice || 0,
    currency: "EUR",
  });
};
